import { Alert, ControlType } from "@tag/tag-components-react-v4";
import { CSSProperties, FC } from "react";
import "./errorMessage.css";

type ErrorMessageProps = {
  dataType: string;
  showMessage?: boolean;
  fontSize?: string;
  messageType?: ControlType;
  message?: string;
};

const ErrorMessage: FC<ErrorMessageProps> = ({
  dataType,
  fontSize = "11",
  showMessage = true,
  messageType = "error",
  message,
}) => {
  const customStyles = {
    "--custom-font-size": fontSize,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  } as CSSProperties;
  return (
    <div className="error-message-container" style={customStyles}>
      <Alert closeTransition="fade" type={messageType}>
        {showMessage &&
          !message &&
          `Error loading ${dataType}, refresh the page to try again`}
        {showMessage && message && message}
      </Alert>
    </div>
  );
};

export default ErrorMessage;
